export default {
  title: 'Bon afdrukken',
  sections: {
    destination: 'Bonnen afdrukken op',
  },
  printers: {
    inner: {
      title: 'Ingebouwde printer',
    },
    external: {
      title: 'Externe printer',
      width_unset: 'Papierbreedte niet ingesteld',
      connect_hint: 'Verbind een printer om deze te gebruiken',
      disconnect_confirm: 'Deze printer loskoppelen?',
      disconnect_confirm_description: 'Je moet hem opnieuw instellen.',
      disconnect_confirm_ok: 'Ja, loskoppelen',
    },
  },
  // One block per printer state. `label` is the printer row's sub-line segment;
  // `title` and `description` are the status alert. `{{name}}` is the printer's name.
  statuses: {
    connected: {
      label: 'Gereed',
      title: 'Klaar om af te drukken',
      description: '{{name}}',
    },
    paper_near_end: {
      label: 'Papier bijna op',
      title: 'Papier is bijna op',
      description: 'Vervang de rol snel. Afdrukken gaat door.',
    },
    busy: {
      label: 'Bezig',
      title: 'Printer is bezig',
      description: '{{name}} verwerkt een andere taak.',
    },
    not_configured: {
      label: 'Niet ingesteld',
      title: 'Niet ingesteld',
      description: '{{name}} moet worden ingesteld voordat er afgedrukt kan worden.',
    },
    offline: {
      label: 'Offline',
      title: 'Drukt niet af',
      description: '{{name}} is offline. Nieuwe bestellingen worden niet afgedrukt.',
      // Used when auto-print is off — nothing is silently failing to print.
      title_idle: 'Offline',
      description_idle: '{{name}} is niet verbonden.',
    },
    cover_open: {
      label: 'Klep open',
      title: 'Klep is open',
      description: 'Sluit de printerklep om het afdrukken te hervatten.',
    },
    paper_empty: {
      label: 'Geen papier',
      title: 'Geen papier',
      description: 'Vervang de rol om het afdrukken te hervatten.',
    },
    wrong_paper: {
      label: 'Verkeerd papier',
      title: 'Verkeerd papier',
      description: 'De geplaatste rol komt niet overeen met de ingestelde papierbreedte.',
    },
    cutter_error: {
      label: 'Snijderfout',
      title: 'Snijderfout',
      description: 'Controleer de snijder op vastgelopen papier en probeer opnieuw.',
    },
    overheat: {
      label: 'Te heet',
      title: 'Printer te heet',
      description: 'Laat {{name}} afkoelen voordat je opnieuw afdrukt.',
    },
    error: {
      label: 'Fout',
      title: 'Printerfout',
      description: '{{name}} meldt een fout en vereist aandacht.',
    },
    connecting: {
      label: 'Verbinden…',
      title: 'Verbinden…',
      description: '{{name}}',
    },
    disconnected: {
      label: 'Niet verbonden',
      title: 'Niet verbonden',
      description: '{{name}} is niet verbonden.',
    },
  },
  form: {
    auto_print: {
      label: 'Nieuwe bestellingen automatisch afdrukken',
      not_ready:
        'Automatisch afdrukken is aan, maar de externe printer is niet gereed. Bestellingen worden niet afgedrukt.',
    },
    print_copies: {
      label: 'Exemplaren per bestelling',
      hint: 'Zet automatisch afdrukken aan om exemplaren in te stellen',
      decrease: 'Exemplaren verminderen',
      increase: 'Exemplaren verhogen',
    },
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
  },
  buttons: {
    test_print: 'Testafdruk',
    configure_external: 'Configureren',
    connect_external: 'Printer verbinden',
    disconnect_external: 'Loskoppelen',
    retry_connection: 'Verbinding opnieuw proberen',
    cancel: 'Annuleren',
  },
};
